import React, { useState, useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SVGPureIcon } from '@/ui';
import { HelperCore, HelpOther } from '@/common/helper';
import { request } from '@src/common';
import './index.scss';
import CircleLoading from '@/components/ani/circle-loading';

const name = 'xiaohongshu-shop';

const NoteCard = observer(({ data, checked, onSelect, enableAdd }) => {
  const { cover, name, price, platform, product_id, status } = data;

  return (
    <div
      className={`xiaohongshu-card group w-full mx-8px cursor-pointer border-1px border-black border-opacity-0 hover:border-opacity-3 bg-black bg-opacity-0 hover:bg-opacity-2 rounded-12px p-8px ${checked || status === 'success' ? '!border-opacity-100' : ''}`}
      onClick={() => {
        if (!enableAdd) {
          return;
        }
        onSelect(product_id)
      }}
    >
      <div className="w-full h-128px relative rounded-3px overflow-hidden">
        <img className="w-full h-full object-cover" src={cover} alt="" />
        {
          enableAdd ? (
            <div
              className={`min-w-16px flex justify-center items-center size-16px rounded-3px border-1px border-black absolute right-0 top-0 bg-white ${checked ? 'bg-black' : 'border-opacity-20'}`}
            >
              {
                checked ? (
                  <SVGPureIcon
                    className="relative size-12px text-white"
                    name="check"
                  />
                ) : null
              }
            </div>
          ) : null
        }
      </div>
      <div className="w-full h-40px mt-14px line-clamp-2 leading-20px">
        {name}
      </div>
      <div className="w-full mt-14px">
        <div className='text-[#ff3b30] font-bold text-16px'>¥{price}</div>
        <span className='h-18px leading-18px text-12px text-black text-opacity-50 px-6px bg-black bg-opacity-6 rounded-4px inline-block'>{platform}</span>
      </div>
    </div>
  );
});

const statusText = {
  '0': '需要将以下商品加入购物车吗？',
  '1': '我成功为您将已勾选的商品加入淘宝/京东购物车！',
  '-1': '抱歉，您勾选的商品加入购物车失败～可在右侧报告中进入商品详情页手动加购'
}

const colors = {
  '0': 'text-[#000]',
  '1': 'text-[#008000]',
  '-1': 'text-[#f00]'
}

const XiaohongshuShop = props => {
  const { 
    list = [],
    action_name = '',
    request_id = '',
    isMcpShare,
    mcpStore,
    is_doing,
    status,
  } = props;
  console.log('xiaohongshu-shop', props);
  
  const [isFold, setFold] = useState(false);
  const [selectList, setSelectList] = useState([]);
  const [addStatus, setAddStatus] = useState(0);
  const refShop = useRef(null);
  const refShopTip = useRef(null);
  const refShopHolder = useRef(null);

  useEffect(() => {
    if (status === 'success') {
      let hasSuccess = false;
      let hasFail = false;
      let val = 0;
      list.map(item => {
        if (item.status === 'success') {
          hasSuccess = true;
        } else if (item.status === 'fail') {
          hasFail = true;
        }
      })
      if (hasSuccess) {
        val = 1;
      } else if (hasFail) {
        val = -1;
      }
      setAddStatus(val);
      setSelectList([]);
      refShopHolder?.current?.scrollIntoView();
    }
  }, [status]);
  

  const onSelect = (id) => {
    if (!id) {
      return;
    }
    const select = Object.assign([], selectList);
    const index = select.indexOf(id);
    if (index > -1) {
      select.splice(index, 1);
    } else {
      select.push(id)
    }
    setSelectList(select);
  }

  const submit = (isConfirm) => {
    // mcp分享页不能进行操作
    if (isMcpShare) {
      HelpOther.toast('该页面不能进行此操作！', 'error')
      return;
    }

    let res = list.filter(item => {
      return selectList.includes(item.product_id)
    }).map(item => {
      return {
        product_id: item.product_id,
        url: item.url,
        platform: item.platform,
        name: item.name,
      }
    })

    // 取消
    if (!isConfirm) {
      res = [];
    }

    if (isConfirm && res.length === 0) {
      HelpOther.toast('请选择要加入购物车的商品！', 'error')
      return;
    }
    
    request.post('/mcp/ws/user_action_confirm', {
      request_id,
      action_name,
      user_choice: JSON.stringify(res),
    }, {
      dataIsJson: true
    }).then(res => {
      const { code, data } = res;
      if (code === 0) {
        HelpOther.toast(
          isConfirm ? '您已确认将所勾选的商品加入购物车，我将开始为您逐一添加。' : '您已确认取消将以上商品加入购物车，我将结束当前任务。',
          'success'
        )
        setTimeout(() => {
          document.querySelector('div[data-tool="add_shopping_cart"]')?.scrollIntoView();
        }, 1000);
        //隐藏按钮
        const el = refShop?.current;
        if (el) {
          el.style.display = 'none'
        }
        const tip = refShopTip?.current;
        if (tip) {
          tip.style.display = 'none'
        }
      }
    }).catch(err => {
      HelpOther.toast(
        isConfirm ? '商品暂时无法加入购物车，请重试。' : '取消加入购物车的操作执行失败，请重试。',
        'error'
      )
    })
  }

  if(!list?.length) return null;

  return (
    <div>
      <h3 className="h-22px mb-0 flex items-center text-16px text-black font-bold-600" ref={refShopHolder}>
        <img src={mcpStore?.agentInfo.icon} className="size-24px mr-8px rounded-6px" />
        {mcpStore?.agentInfo.title}
      </h3>
      <div className={`h-28px my-12px ${colors[addStatus]}`}>{statusText[addStatus]}</div>
      <div className={[
        'w-[80%] rounded-12px bg-white p-16px border-[1px] border-[rgba(0, 0, 0, 0.1)]',
        'overflow-hidden',
      ]}>
        <div className={`relative xiaohongshu-swiper`}>
          <Swiper
            className="w-full"
            direction="horizontal"
            slidesPerView={'auto'}
            slidesPerGroup={3}
            spaceBetween={16}
            navigation={{
              prevEl: `.swiper-btn-prev-${name}`,
              nextEl: `.swiper-btn-next-${name}`,
            }}
          >
            {list.map((item, index) => {
              return (
                <SwiperSlide key={index + item.url} className="!w-126px">
                  <NoteCard data={item} checked={selectList.includes(item.product_id)} onSelect={onSelect} enableAdd={status !== 'success' && is_doing !== 0} />
                </SwiperSlide>
              );
            })}
            <div
              className="mask w-50px h-full absolute top-0 right-0"
              style={{
                background:
                  'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 5%, #FFF 100%)',
              }}
            ></div>
          </Swiper>
          {
            (<div 
              // className="text-[rgba(0,0,0,0.5)]"
            >
              {
                <div
                  className={[
                    `swiper-btn-prev-${name} vh-center size-32px rounded-full`,
                    'absolute top-1/2 -left-8px -mt-43px',
                    'border-1px border-[rgba(0,0,0,0.1)] bg-white hover:bg-[#f7f7f7] cursor-pointer',
                  ]}
                >
                  <SVGPureIcon name="swiper_agent_prev" className="size-21px" />
                </div>
              }
              {
                <div
                  className={[
                    `swiper-btn-next-${name} vh-center size-32px rounded-full`,
                    'absolute top-1/2 -right-8px -mt-43px',
                    'border-1px border-[rgba(0,0,0,0.1)] bg-white hover:bg-[#f7f7f7] cursor-pointer',
                  ]}
                >
                  <SVGPureIcon name="swiper_agent_next" className="size-21px" />
                </div>
              }
            </div>)
          }
          {
            status !== 'success' && is_doing !== 0 ? (
              <div className='flex justify-end mt-16px' ref={refShop}>
                <div
                  className='h-28px leading-20px py-4px px-16px bg-black bg-opacity-6 rounded-16px mr-10px cursor-pointer'
                  onClick={() => {
                    submit(false);
                  }}
                >取消</div>
                <div
                  className='h-28px leading-20px py-4px px-16px bg-black rounded-16px cursor-pointer text-white'
                  onClick={() => {
                    submit(true);
                  }}
                >加入购物车</div>
              </div>
            ) : null
          }
        </div>
      </div>

      {
        status === 'running' && is_doing !== 0 ? (
          <div className="flex h-32px w-max max-w-full rounded-full items-center pl-10px pr-16px mt-10px bg-[#FF3B300F]" ref={refShopTip}>
            <CircleLoading className="!size-16px ml-6px flex-shrink-0" icon="https://p1.ssl.qhimg.com/t11098f6bcd4edd531ca1556acb.png" />
            <div className="text-14px leading-20px text-black ml-10px font-bold truncate text-[#FF3B30]">
              我将在您完成选择后继续工作
            </div>
          </div>
        ) : null
      }
    </div>
  );
};

export default observer(XiaohongshuShop);
